"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const idm_export_client_js_1 = require("@synisys/idm-export-client-js");
const base_export_menu_1 = require("../../export-menu/base-export-menu");
/**
 * Created by aghavni.grigoryan on 10/10/2017.
 */
let ChartExportMenuComponent = class ChartExportMenuComponent extends base_export_menu_1.BaseExportMenu {
    constructor() {
        super();
        // Enum which specified export types in chart.
        this.ExportType = idm_export_client_js_1.ExportType;
        this.export = new core_1.EventEmitter();
    }
};
ChartExportMenuComponent = __decorate([
    core_1.Component({
        
        selector: "sis-chart-export-menu",
        styles: [require('./chart-export-menu.component.css')],
        template: require('./chart-export-menu.component.html')
    }),
    __metadata("design:paramtypes", [])
], ChartExportMenuComponent);
exports.ChartExportMenuComponent = ChartExportMenuComponent;
//# sourceMappingURL=chart-export-menu.component.js.map